import { render, staticRenderFns } from "./SqlViewWidgetPreview.vue?vue&type=template&id=b2e45f68&scoped=true"
import script from "./SqlViewWidgetPreview.vue?vue&type=script&lang=js"
export * from "./SqlViewWidgetPreview.vue?vue&type=script&lang=js"
import style0 from "./SqlViewWidgetPreview.vue?vue&type=style&index=0&id=b2e45f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e45f68",
  null
  
)

export default component.exports